import React, { useEffect } from "react";
// styled components
import { Row, Col, Tabs } from "antd";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../components/BannerPanel";
import { MenuUsuario } from "../components/MenuUsuario";
import { Footer } from "../../../components/Landing/Footer";
import { Misbeps } from "./MisBeps";
import { SubsanarDocumentos } from "./components/SubsanarDocumentos";
import { useMisBeps } from "../../../hooks/useMisBeps";
import ModalWarning from "../../../utils/Alerts/ModalWarning";

export const BepsUsuario = () => {
  const {
    totaldocumentossubsanar,
    cargarPostulaciones,
    setOpenModalWarning,
    openModalWarning,
    onAceptar
  } = useMisBeps();

  useEffect(() => {
    cargarPostulaciones();
  }, []);

  return (
    <>
      <Header />
      <BannerPanel />
      <div className="container-fluid2">
        <div
          className="row mt-3"
        >
          <MenuUsuario activeItem={2} />
          <div className="col-12 col-md-12 col-lg-10">
            <Tabs
              defaultActiveKey="1"
              // activeKey={principalState.activeTab}
              // onChange={onChange}
              className="height-100 col-12 background-color-FFFFFF"
            >
              <Tabs.TabPane
                tab="Mis Beps"
                key="1"
                className="height-100 font-size-13px font-family-Montserrat-Regular"
              >
                <Misbeps />
                {/* <Crearinivitacion cambiarPestaña={setPrincipalState} activeItem={principalState} /> */}
              </Tabs.TabPane>
              <Tabs.TabPane
                tab="Subsanar documentos"
                key="2"
                className="height-100 font-size-13px font-family-Montserrat-Regular"
              >
                <SubsanarDocumentos />
                {/* <CronogramaActividades cambiarPestaña={setPrincipalState} activeItem={principalState} /> */}
              </Tabs.TabPane>
            </Tabs>
          </div>
        </div>
      </div>
      <Footer />
      <ModalWarning
        visualizar={openModalWarning}
        setVisualizar={setOpenModalWarning}
        titlle="Advertencia"
        onAceptar={onAceptar}
        description={"Tienes documentos pendientes por subsanar"}
        subdescription="Seleccione la pestaña 'Subsanar documentos' para ver todos los documentos."
      />
    </>
  );
};